<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container">
                    <div class="page-links">
                        <router-link to="/trips/tanzania" class="page-links__item is-active">Tanzania Day Trips</router-link>
                        <router-link to="/trips/safari" class="page-links__item">Safari Activities</router-link>
                        <router-link to="/trips/island" class="page-links__item">Island Activities</router-link>
                    </div>
                    <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
            <section class="np-detail" v-if="isLoad">
              <div class="page-title">
                <h2>Mainland Tanzania Day Trips</h2>
              </div>
                <div class="section-title">
                    <h3>{{isEdit ? 'Edit Tanzania Day Trip' : 'Add Tanzania Day Trip'}}</h3><a @click="$router.back()" href="javascript:void(0)" class="btn btn--back">
                    <div class="btn--back__icon">
                        <svg width="1em" height="1em" class="icon icon-collapse ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                        </svg>
                    </div><span>Back</span></a>
                </div>
              <form action="javascript:void(0)" class="np-detail-form">
                <div class="np-detail-section">
                  <div class="np-detail-section__title"><span>1. Info</span></div>
                  <div
                    v-for="item in info"
                    :key="item.title"
                    :class="['np-detail-collapse', 'js-collapse', { 'is-collapsed' : item.collapse }]">
                    <div class="np-detail-collapse__title">
                      <div class="np-detail-collapse__lang">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-gb ">
                            <use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use>
                          </svg>
                        </div><span class="np-detail-collapse__lang__text">{{item.title}}</span>
                      </div>
                      <button
                        type="button"
                        data-opened="Hide" data-closed="Show"
                        :class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': item.collapse }]"
                        @click="item.collapse = !item.collapse"
                        >
                        <div class="btn--collapse__icon">
                          <svg width="1em" height="1em" class="icon icon-collapse ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                          </svg>
                        </div>
                      </button>
                    </div>
                    <div class="np-detail-collapse__inner js-collapse-inner">
                      <div class="np-detail-collapse__body">
                        <div class="np-detail-collapse__body__group">
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Name</span>
                              <div class="form-control-wrap">
                                <input type="text" placeholder="Day Trip name" v-model="item.name" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__group">
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.note" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__group">
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">
                                <svg width="1em" height="1em" class="icon icon-checkmark-rounded ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-checkmark-rounded"></use>
                                </svg> The cost includes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.include" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">
                                <svg width="1em" height="1em" class="icon icon-close-rounded ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close-rounded"></use>
                                </svg> The cost excludes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.excludes" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="np-detail-section">
                  <div class="np-detail-section__filters">
                    <div class="np-detail-section__filters__inner">
                      <div class="form-control-group form-control-group--lg"><span class="form-control-label">Duration (in minutes)</span>
                        <div :class="['form-control-wrap', {'is-error' : errors.duration}]">
                          <input type="number" placeholder="Duration" @input="isEditFlag = true" v-model="duration" @focus="errors.duration = false" class="form-control"/>
                        </div>
                      </div>
                    </div>
                    <div class="form-control-photo-group form-control-photo-group--squared">
						<input type="file" :id="'photo_load'" class="input-hidden"/>
						<label  class="form-control-photo"  v-if="!photo" @click="$emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
						<div class="form-control-photo" v-if="photo"><span class="form-control-photo__box h-object-fit"><img
								:src="`${API}/documents/share/images/${photo}?size=LARGE`" alt="photo"></span>
							<button type="button" class="btn btn--remove" @click="photo = null">
								<svg width="1em" height="1em" class="icon icon-close ">
								<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
								</svg>
							</button>
							</div>
						<div class="form-control-photo-content">
							<div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
							<div class="form-control-photo-content__line">
								<label  class="btn btn--rounded btn-photo-load" @click="$emit('changeImage', 'itinerary')" >{{photo ? 'Change photo' : 'Add Photo'}}</label>
							</div>
							<div class="form-control-photo-content__line" v-if="!photo"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
						</div>
					</div>
                  </div>
                </div>
                <div class="np-detail-section">
                  <div class="np-detail-section__title np-detail-section__title--no-border"><span>2. Age settings</span></div>
                  <div class="age-settings">
                    <div class="age-box">
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>Min Age</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" @input="isEditFlag = true" v-model="age.min" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-child ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Child</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>To</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" @input="isEditFlag = true" v-model="age.child" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-teenager ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Teenager</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>From</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" @input="isEditFlag = true" v-model="age.teenFrom" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>To</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" @input="isEditFlag = true" v-model="age.teenTo" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-adult ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Adult</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>From</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" @input="isEditFlag = true" v-model="age.adult" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <TanzaniaPrices @notLeavePopupHandler="data => $emit('notLeavePopupHandler', data)"  @deleteModalHandler="data => $emit('deleteModalHandler', data)"  :tanzania="tanzania" :user="user" :save="save"/>
                <div class="np-detail-form__submit np-detail-form__submit--no-border">
                    <button type="button" class="btn btn--silver" @click="deleteTanzaniaHandler()" v-if="isEdit"> <span>Delete</span></button>
                    <button type="button" class="btn btn--green btn--shadowed" @click="isEdit ? updateTanzaniaHandler() : createTanzaniaHandler()"><span>{{isEdit ? 'Save' : 'Add'}}</span></button>
                </div>
              </form>
            </section>
          </div>
        </div>
        </main>
    </div>
</template>

<script>

    import {
        uploadUserImage,
        API,
        createTanzania,
        updateTanzania,
        getTanzania,
        deleteTanzania
    } from '@/utilites/api'


    import CKEditor from '@ckeditor/ckeditor5-vue2'
    import ClassicEditor from '@/utilites/ckeditor'

    import SeasonBox from '@/components/SeasonBox'
    import TanzaniaPrices from '@/components/TanzaniaPrices'

    export default {
        components: { editor: CKEditor.component, SeasonBox, TanzaniaPrices },
        props: ['user', 'uploadedFile'],
        data(){
            return {
				API: API,
                editor: ClassicEditor,
                editorConfig: {
                    placeholder: 'Write description'
                },
                editorConfig2: {
                    placeholder: 'Write notes'
                },
                info: [
                    {
                        title: 'English',
                        icon: 'gb',
                        collapse: true,
                        name: '',
                        desc: '',
                        note: '',
                        include: '',
                        excludes: ''
                    },
                    {
                        title: 'Russian',
                        icon: 'rus',
                        collapse: false,
                        name: '',
                        desc: '',
                        note: '',
                        include: '',
                        excludes: ''
                    },
                ],
                selects: {
                    seasons: false
                },
				photo: null,
                age: {
                    min: '',
                    child: '',
                    teenFrom : '',
                    teenTo: '',
                    adult: ''
                },
                duration: '',
				isEdit: false,
				tanzania: null,
                save: 0,
				isLoad: false,
				errors: {
					duration: false
				},
				isEditFlag: false
            }
        },
		beforeRouteLeave(to, from, next){
			if(this.isEditFlag){
				this.$emit('notLeaveHandler')
			}
			next()
		},
        methods: {
			checkError(){
				let error = false
				if(this.duration.length <= 0){
					error = true
					this.errors.duration = true
				}
				document.querySelectorAll('.form-control-name').forEach(elem => {
					if(elem.value.trim().length <= 0){
						elem.parentElement.classList.add('is-error')
						error = true
					}
				})
				document.querySelectorAll('.form-control-age').forEach(elem => {
					if(elem.value.trim().length < 0 || +elem.value <= 0){
						elem.parentElement.classList.add('is-error')
						error = true
					}
				})
				return error
			},
            createTanzaniaHandler(){
				if(!this.checkError()){
					createTanzania(this.user.access_token, {
						"photo": this.photo,
						"info": {
							"EN": {
								"name": this.info[0].name,
								"description": this.info[0].desc,
								"whatToBring": this.info[0].note,
								"costIncludes": this.info[0].include,
								"costExcludes": this.info[0].excludes
							},
							"RU": {
								"name": this.info[1].name,
								"description": this.info[1].desc,
								"whatToBring": this.info[1].note,
								"costIncludes": this.info[1].include,
								"costExcludes": this.info[1].excludes
							},
						},
						duration: this.duration,
						"ageSettings": {
							"minAge": +this.age.min,
							"child": {
								"from": +this.age.min,
								"to": +this.age.child
							},
							"teenager": {
								"from": +this.age.teenFrom,
								"to": +this.age.teenTo
							},
							"adult": {
								"from": +this.age.adult,
								"to": 100
							}
						}
					})
					.then(res => {
						this.save += 1
						this.tanzania = res
						this.isEdit = res.id
						this.$emit('confirmed')
						this.isEditFlag = false
					})
				} else {
					window.scrollTo({
						top: 0
					})
				}
			},
			updateTanzaniaHandler(){
				if(!this.checkError()){
					updateTanzania(this.user.access_token, {
						id: this.tanzania.id,
						"photo": this.photo,
						"info": {
							"EN": {
								"name": this.info[0].name,
								"description": this.info[0].desc,
								"whatToBring": this.info[0].note,
								"costIncludes": this.info[0].include,
								"costExcludes": this.info[0].excludes
							},
							"RU": {
								"name": this.info[1].name,
								"description": this.info[1].desc,
								"whatToBring": this.info[1].note,
								"costIncludes": this.info[1].include,
								"costExcludes": this.info[1].excludes
							},
						},
						duration: this.duration,
						"ageSettings": {
							"minAge": +this.age.min,
							"child": {
								"from": +this.age.min,
								"to": +this.age.child
							},
							"teenager": {
								"from": +this.age.teenFrom,
								"to": +this.age.teenTo
							},
							"adult": {
								"from": +this.age.adult,
								"to": 100
							}
						}
					})
					.then(() => {
						this.$emit('confirmed')
						this.isEditFlag = false
					})
					this.save += 1
				} else {
					window.scrollTo({
						top: 0
					})
				}
			},
            deleteTanzaniaHandler(){
				deleteTanzania(this.user.access_token, this.tanzania.id)
				.then(res => {
					this.$router.back()
				})
			}
        },
        beforeCreate(){
           document.title = 'Day Trips & Activities / Mainland Tanzania'
        },
        mounted(){
            document.title = 'Day Trips & Activities / Mainland Tanzania'
            this.isEdit = this.$route.params.id
            if(this.isEdit){
				getTanzania(this.user.access_token, this.isEdit)
				.then(res => {
					this.tanzania = res
					this.isLoad = true
					this.info = [
						{
							title: 'English',
							icon: 'gb',
							collapse: false,
							name: res.info.EN.name,
							desc: res.info.EN.description,
							note: res.info.EN.whatToBring,
                            include: res.info.EN.costIncludes,
                            excludes: res.info.EN.costExcludes
						},
						{
							title: 'Russian',
							icon: 'rus',
							collapse: false,
							name: res.info.RU.name,
							desc: res.info.RU.description,
							note: res.info.RU.whatToBring,
                            include: res.info.RU.costIncludes,
                            excludes: res.info.RU.costExcludes
						},
					]
					this.photo = res.photo
                    this.duration = res.duration
					this.age = {
						min: res.ageSettings.minAge,
						child: res.ageSettings.child.to,
						teenFrom : res.ageSettings.teenager.from,
						teenTo: res.ageSettings.teenager.to,
						adult: res.ageSettings.adult.from
					}
				})
			} else {
				this.isLoad = true
			}
        },
		watch: {
			uploadedFile(){
				if(this.uploadedFile){
					this.photo = this.uploadedFile
				}
			}
		}
    }
</script>
